/* eslint-disable @typescript-eslint/no-explicit-any */
import {ForwardedRef, MutableRefObject} from 'react';

/**
 * Sets a reference to either a 'MutableRefObject' or callable reference function.
 * Example usage:
 * - setRef(ref)(value)
 */
export const setRef =
    (ref: ((value: unknown) => void) | ForwardedRef<any>) =>
    (value: unknown) => {
        if (ref) {
            if (typeof ref === 'function') {
                ref(value);
            } else {
                ref.current = value;
            }
        }
    };

export const mergeRefs = <T = unknown>(
    ...refs: (ForwardedRef<T> | MutableRefObject<T>)[]
) => {
    return (instance: T) => {
        if (!instance) return;
        refs.forEach((ref) => {
            if (typeof ref === 'function') {
                ref(instance);
            } else if (ref) {
                ref.current = instance;
            }
        });
    };
};
